import React, { useCallback, useEffect, useRef, useState } from "react";
import { OrgChart } from "d3-org-chart";
import * as d3 from "d3";
import * as ReactDOMClient from "react-dom/client";
import OrgNode from "./OrgNode";
import {
  chartAdd,
  chartDragAndDrop,
  chartEditResearch,
  chartMidLevelAdd,
  deleteChartResearch,
  getChartNew,
  getLinearChart,
  getshareLink,
  unAssignUserResearch,
} from "../services/frontService/ChartService";
import NodeEditResearch from "../components/shared/NodeEditResearch";
import { Tooltip } from "react-tooltip";
import Button from "../components/form/Button";
import CopyUrl from "../components/modals/front/CopyUrl";
import SearchWithDropdown from "../components/form/SearchWithDropdown";
import { getEmployeeList } from "../services/frontService/EmployeeService";
import { useDebounce } from "../helpers/useDebounce";
import { toast } from "react-toastify";
import NodeDelete from "../components/modals/front/NodeDelete";
import AssignModal from "../components/common/DeleteModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ExportDropdown from "../layouts/shared/ExportDropdown";
import MultiselectDropdown from "../components/form/MultiselectDropdown";
import { useSelector } from "react-redux";
import { getDepartmentList } from "../services/frontService/DepartmentService";
import ToggleSwitch from "../components/form/ToggleSwitch";
import CsvUploadResearchChart from "../components/modals/front/CsvUploadResearchChart";
import { useNavigate } from "react-router-dom";
import ToogleButton from "../components/form/ToggleButton";
import { useSsoChart } from "../Context/ChartSsoContext";
import { DndContext, closestCenter } from "@dnd-kit/core";

const TestChart = () => {
  const d3Container = useRef();
  const chartRef = useRef(null);
  const navigate = useNavigate();
  const [chartData, setChartData] = useState([]);
  const [selectUser, setSelectUser] = useState(null);
  const [isSidepanelOpen, setSidePanelOpen] = useState({
    isOpen: false,
  });
  const [highlightedNodeId, setHighlightedNodeId] = useState(null);
  const [copyUrlModal, setCopyUrlModal] = useState({ isOpen: false, data: {} });
  const [empList, setEmpList] = useState({ loading: false, data: [] });
  const [keyword, setKeyword] = useState("");
  const debKeyword = useDebounce(keyword, 300);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [empDetails, setEmpDetails] = useState({ loading: false, data: {} });
  const [partialTree, setPartialTree] = useState(false);
  const [importModal, setImportModal] = useState({ isOpen: false });
  const [isLoading, setLoading] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: {},
  });
  const [parentNode, setParentNode] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const profile = useSelector((state) => state?.profile?.data);
  const [assignModal, setAssignModal] = useState({
    isOpen: false,
  });
  const userRole = profile?.role?.find(
    (item) => item?.code === "COMPANY-MANAGER"
  );
  const [view, setView] = useState("hierarchy");
  const [department, setDepartment] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUnassigned, setIsUnassigned] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("single");
  const {
    setDetails,
    setSyncDataModalOpen,
    setSelectedSite,
    getGenarateToken,
  } = useSsoChart();
  const loadempList = useCallback(() => {
    setEmpList({ loading: true, data: [] });
    getEmployeeList({ keyword: debKeyword, limit: 40, chart: true })
      .then((res) => {
        setEmpList({
          loading: false,
          data: res?.status === 200 ? res?.docs : [],
        });
      })
      .catch(() => {
        setEmpList({ loading: false, data: [] });
      });
  }, [debKeyword]);

  useEffect(() => loadempList(), [loadempList]);

  const transformData = (rawData) => {
    const ids = new Set(rawData.map((item) => item._id));

    return rawData.map((item) => ({
      id: item._id,
      ...item,
      parentId: ids.has(item.parentId) ? item.parentId : "",
    }));
  };
  const exportPartialTree = () => {
    if (isSidepanelOpen?._id === empDetails?.data?._id) {
      setLoading(true);
      getChartNew({ specificCardId: isSidepanelOpen?._id }).then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          setChartData(res?.docs?.length > 0 && res?.docs);
          setPartialTree(true);
        }
      });
    }
  };
  const loadLinearChart = useCallback(() => {
    const payload =
      Array.isArray(selectedDepartments) && selectedDepartments.length > 0
        ? { departmentId: selectedDepartments[0] }
        : undefined;
    getLinearChart(payload)
      .then((res) => {
        const docs = res?.docs || [];
        const transformed = transformData(docs);
        setChartData(transformed);
        setPartialTree(
          Array.isArray(selectedDepartments) && selectedDepartments.length > 0
        );
        setParentNode(res?.docs?.length > 0 && res?.docs[0]?._id);
      })
      .catch((err) => {
        console.error("Error fetching chart data:", err);
      });
  }, [selectedDepartments]);

  useEffect(() => {
    loadLinearChart();
  }, [loadLinearChart]);

  const handleAddNode = (node) => {
    // setLoading(true);
    chartAdd({
      parentId: node?._id,
    }).then((res) => {
      // setLoading(false);
      if (res?.status === 200) {
        toast.success("Chart added successfully");
        loadLinearChart();
        setSidePanelOpen((pre) => ({
          ...pre,
          isOpen: true,
          _id: res?.data?._id,
        }));
      } else {
        toast.error("Something went wrong!");
      }
    });
  };
  const editNode = (nodeDatum, mode = "edit") => {
    return chartEditResearch({
      id: isSidepanelOpen?._id,
      payload: nodeDatum,
    }).then((res) => {
      if (res?.status === 200) {
        toast.success("Chart edited successfully");
        loadLinearChart();
        return res;
      } else {
        toast.error(res?.data?.message || "Something went wrong !");
        setSidePanelOpen((pre) => ({ isOpen: false }));
        return res;
      }
    });
  };
  const deleteNode = () => {
    const nodeDatum = isDeleteModal?.data;
    const nodeId = nodeDatum?._id;
    if (!nodeId) {
      toast.error("Node ID not found");
      return;
    }
    setIsDeleting(true);
    deleteChartResearch({
      id: nodeId,
      payload: { deletionStatus: deleteStatus },
    }).then((res) => {
      setIsDeleting(false);
      if (res?.status === 200) {
        toast.success("Chart deleted successfully");
        setSidePanelOpen((pre) => ({ ...pre, isOpen: false }));
        setDeleteModal((pre) => ({ ...pre, isOpen: false }));
        loadLinearChart();
      } else {
        toast.error(res?.data?.message || "Something went wrong !");
      }
    });
  };
  const usAssignNode = () => {
    setAssignModal((pre) => ({ ...pre, loading: true }));
    unAssignUserResearch({
      id: assignModal?._id,
    }).then((res) => {
      // setLoading(false);
      if (res?.status === 200) {
        toast.success("Unassigned successfully");
        setSidePanelOpen((pre) => ({ ...pre, isOpen: false }));
        setEmpDetails((pre) => ({ ...pre, data: {} }));
        setAssignModal((pre) => ({ ...pre, loading: false, isOpen: false }));
        setSelectUser(null);
        setSelectedPosition(null);
        loadLinearChart();
      } else {
        toast.error(res?.data?.message || "Something went wrong !");
      }
    });
  };
  const addAboveNode = (node) => {
    setLoading(true);
    chartMidLevelAdd({
      referenceId: node?._id,
      direction: "up",
    }).then((res) => {
      setLoading(false);
      if (res?.status === 200) {
        toast.success("Chart added successfully");
        loadLinearChart();
        setSidePanelOpen((pre) => ({
          ...pre,
          isOpen: true,
          _id: res?.data?._id,
        }));
        setSelectUser(null);
        setSelectedPosition(null);
      } else {
        // toast.error(
        //   userRole?.code === "COMPANY-MANAGER"
        //     ? "Only administrators have permission to add nodes to the org chart."
        //     : "Something went wrong!"
        // );
      }
    });
  };
  const handleNodeClick = (node) => {
    setSidePanelOpen({ isOpen: true, _id: node?._id });
  };
  const handleZoomIn = () => {
    if (chartRef.current) chartRef.current.zoomIn();
  };

  const handleZoomOut = () => {
    if (chartRef.current) chartRef.current.zoomOut();
  };

  const handleReset = () => {
    if (chartRef.current) chartRef.current.fit();
  };
  const shareChart = () => {
    setCopyUrlModal({ isOpen: true });
    getshareLink().then((res) => {
      if (res?.status === 200) {
        setCopyUrlModal((pre) => ({ ...pre, data: res?.data }));
      }
    });
  };

  useEffect(() => {
    if (chartData?.length > 0 && d3Container.current) {
      const chart = new OrgChart()
        .container(d3Container.current)
        .data(chartData)
        .nodeWidth(() => 220)
        .nodeHeight(() => 108)
        .compact(true)
        .childrenMargin(() => 40)
        .compactMarginBetween(() => 20)
        .compactMarginPair(() => 20)
        .nodeContent(
          (d) =>
            `<div id="node-${
              d?.data?._id
            }" class="draggable-node" data-node-id="${
              d?.data?._id
            }" data-parent-id="${d?.data?.parentId || ""}"></div>`
        )
        .linkUpdate((d, i, arr) => {
          d3.select(arr[i])
            .attr("stroke", "#000")
            .attr("fill", "none")
            .attr("stroke-width", 2)
            .attr(
              "d",
              (d) =>
                `M${d.x},${d.y} C${d.x},${(d.y + d.parent.y) / 2} ${
                  d.parent.x
                },${(d.y + d.parent.y) / 2} ${d.parent.x},${d.parent.y}`
            );
        });

      chart.render().expandAll().fit();

      // const svgSelection = d3.select(d3Container.current).select("svg");
      // svgSelection.on(".zoom", null);
      // svgSelection.on("wheel.zoom", null);
      // svgSelection.on("mousedown.zoom", null);

      chartRef.current = chart;

      const renderNode = (node) => {
        const nodeContainer = document.getElementById(`node-${node?._id}`);
        if (nodeContainer) {
          const root = ReactDOMClient.createRoot(nodeContainer);
          root.render(
            <OrgNode
              node={node}
              highlighted={highlightedNodeId}
              onAdd={(data, type) => handleAddNode(data, type)}
              onClick={() => handleNodeClick(node)}
              setDeleteModal={setDeleteModal}
              setAssignModal={setAssignModal}
              addAboveNode={addAboveNode}
              isUnassigned={isUnassigned}
              setDetails={setDetails}
              setSyncDataModalOpen={setSyncDataModalOpen}
              setSelectedSite={setSelectedSite}
              getGenarateToken={getGenarateToken}
            />
          );
        }
      };

      const renderAllNodes = () => chartData.forEach((n) => renderNode(n));

      renderAllNodes();

      chart.onExpandOrCollapse(() => {
        renderAllNodes();
        chart.fit();
      });

      // ✅ Helper function to check if target is a descendant of source
      const isDescendantOf = (sourceNode, targetId, allNodes) => {
        const findDescendants = (nodeId) => {
          const children = allNodes.filter((n) => n.parentId === nodeId);
          let descendants = [...children];
          children.forEach((child) => {
            descendants = [...descendants, ...findDescendants(child._id)];
          });
          return descendants;
        };

        const descendants = findDescendants(sourceNode._id);
        return descendants.some((d) => d._id === targetId);
      };

      const drag = d3
        .drag()
        .filter(function (event) {
          const target = event.target;
          // Allow drag only if NOT clicking on interactive elements
          const hasNoInteraction =
            !target.closest(
              "button, a, input, select, textarea, img, [onclick]"
            ) &&
            !target.classList.contains("no-drag") &&
            target.tagName !== "BUTTON" &&
            target.tagName !== "A" &&
            target.tagName !== "IMG";

          return hasNoInteraction;
        })
        .on("start", function (event) {
          const nodeId = d3.select(this).attr("data-node-id");
          const parentId = d3.select(this).attr("data-parent-id");
          const nodeData = chartData.find((n) => n._id === nodeId);

          if (!parentId || !nodeData?.parentId) {
            console.log("Root node cannot be dragged");
            return;
          }

          this.__data__ = nodeData;
          this.__startX__ = event.x;
          this.__startY__ = event.y;

          // Create dragging clone
          const clone = this.cloneNode(true);
          clone.id = "dragging-clone";
          clone.style.position = "fixed";
          clone.style.pointerEvents = "none";
          clone.style.zIndex = "9999";
          clone.style.opacity = "0.8";
          clone.style.left = `${event.sourceEvent.clientX}px`;
          clone.style.top = `${event.sourceEvent.clientY}px`;
          clone.style.transform = "translate(-50%, -50%)";

          document.body.appendChild(clone);
          this.__clone__ = clone;

          d3.select(this).style("opacity", 0.3);

          // Add drop target styling
          d3.selectAll(".draggable-node")
            .filter(function () {
              const isNotSelf =
                this !== event.sourceEvent.target.closest(".draggable-node");
              const targetNodeId = d3.select(this).attr("data-node-id");
              const isNotDescendant = !isDescendantOf(
                nodeData,
                targetNodeId,
                chartData
              );
              return isNotSelf && isNotDescendant;
            })
            .classed("drop-target", true)
            .on("mouseenter", function () {
              d3.select(this).classed("drop-hover", true);
              const hoverId = d3.select(this).attr("data-node-id");
              // setHoverDropedId(hoverId);
            })
            .on("mouseleave", function () {
              d3.select(this).classed("drop-hover", false);
              // setHoverDropedId(null);
            });
        })
        .on("drag", function (event) {
          const parentId = d3.select(this).attr("data-parent-id");
          if (!parentId || !this.__data__?.parentId) {
            return;
          }

          // Move the clone with cursor
          if (this.__clone__) {
            this.__clone__.style.left = `${event.sourceEvent.clientX}px`;
            this.__clone__.style.top = `${event.sourceEvent.clientY}px`;
          }
        })
        .on("end", function (event) {
          const draggedNodeData = this.__data__;

          const parentId = d3.select(this).attr("data-parent-id");
          if (!parentId || !draggedNodeData?.parentId) {
            return;
          }

          // Remove clone
          if (this.__clone__) {
            this.__clone__.remove();
            delete this.__clone__;
          }

          // Reset original node
          d3.select(this).style("opacity", 1);

          // Remove drop target styling and events
          d3.selectAll(".draggable-node")
            .classed("drop-target", false)
            .classed("drop-hover", false)
            .on("mouseenter", null)
            .on("mouseleave", null);

          // Find which node is under the cursor
          const dropTargetElement = document.elementFromPoint(
            event.sourceEvent.clientX,
            event.sourceEvent.clientY
          );

          const dropTargetNode = dropTargetElement?.closest(".draggable-node");

          if (dropTargetNode && dropTargetNode !== this) {
            const dropTargetId = dropTargetNode.getAttribute("data-node-id");
            const dropTargetData = chartData.find(
              (n) => n._id === dropTargetId
            );

            // Prevent dropping on descendants
            if (
              dropTargetData &&
              !isDescendantOf(draggedNodeData, dropTargetId, chartData)
            ) {
              console.log("Dragged Node:", draggedNodeData);
              console.log("Dropped On Node:", dropTargetData);

              // ✅ Manually update chartData state
              setChartData((prevData) => {
                return prevData.map((node) => {
                  if (node._id === draggedNodeData._id) {
                    // Update the dragged node's parentId
                    return {
                      ...node,
                      parentId: dropTargetId,
                      parentCardDetails: {
                        _id: dropTargetId,
                        cardNumber: dropTargetData.cardNumber,
                        parentUserDetails: dropTargetData.userDetails,
                      },
                    };
                  }
                  return node;
                });
              });

              // Call API to persist changes
              handleDragEnd({
                active: { id: draggedNodeData._id },
                over: { id: dropTargetId },
              });
            } else {
              console.log("Cannot drop on descendant nodes");
              toast.error("Cannot move a node under its own descendant");
              // setActiveId(null);
              // setDraggedNode(null);
              // setHoverDropedId(null);
            }
          } else {
            console.log("Not dropped on any valid node");
            // setActiveId(null);
            // setDraggedNode(null);
            // setHoverDropedId(null);
          }

          delete this.__data__;
          delete this.__startX__;
          delete this.__startY__;
        });

      // Apply drag after render
      setTimeout(() => {
        d3.selectAll(".draggable-node").call(drag);
      }, 300);

      const handleResize = () => chart.fit();
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [chartData, highlightedNodeId,isUnassigned ]);

  // ✅ Your existing handleDragEnd function (modified slightly)
  const handleDragEnd = async ({ active, over }) => {
    try {
      const response = await chartDragAndDrop({
        cardId: active.id,
        parentId: over.id,
      });

      if (response?.status === 200) {
        toast.success(response?.message || "Node moved successfully");
      } else {
        toast.error(
          response?.data?.message || "Failed to update node on server"
        );
        loadLinearChart();
      }
    } catch (error) {
      console.error("Drag-and-drop failed:", error);
      toast.error("Unexpected error occurred while updating the chart.");
      loadLinearChart();
    }
  };

  const onSearch = (selectedUser) => {
    if (selectedUser?._id) {
      setHighlightedNodeId(selectedUser._id);
    } else {
      setHighlightedNodeId("");
    }
  };

  const resetChart = () => {
    loadDeplist();
    loadLinearChart();
  };

  const loadDeplist = useCallback(() => {
    const payload = {
      limit: 300,
      keyword: "",
    };

    getDepartmentList(payload).then((res) => {
      if (res?.status === 200) {
        // setDepList({ loading: false, data: res.docs });
        setDepartment(
          res.docs.map(({ _id, name, departmentEmpCount }) => ({
            _id,
            name,
            value: _id,
            checked: false,
            count: departmentEmpCount,
          }))
        );
      } else {
        // setDepList((prev) => ({ ...prev, data: [], loading: false }));
        toast.error(res?.message);
      }
    });
  }, []);

  useEffect(() => loadDeplist(), [loadDeplist]);
  const selectedDepartment = department.find(
    (dept) => dept._id === selectedDepartments[0]
  );
  const handleToggleChange = (newState) => {
    if (newState) {
      const hasUnassigned = chartData?.some((node) => !node?.userId);
      if (!hasUnassigned) {
        toast.info("There are no open positions !");
        return;
      }
    }
    setIsUnassigned(newState);
  };

  console.log(isUnassigned, "kmjjj");
  const handleToggleViewChange = (isHierarchyView) => {
    const newView = isHierarchyView ? "hierarchy" : "vertical";
    setView(newView);
  };

  useEffect(() => {
    if (view === "vertical") {
      navigate("/researchChart");
    }
  }, [view, navigate]);

  return (
    <>
      <div className="sticky top-0 z-50 w-full bg-white dark:bg-slate-800 shadow-md px-4 py-2 flex flex-col justify-center items-center">
        <h1 className="text-xl md:text-2xl font-extrabold bg-gradient-to-r from-slate-500 via-pink-500 to-orange-500 text-transparent bg-clip-text tracking-tight">
          {selectedDepartment?.name
            ? selectedDepartment?.name
            : profile?.companyDetails?.companyName || "N/A"}
        </h1>
        <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 text-center">
          Organizational Structure of Employees
        </p>
      </div>
      <div
        className="w-full h-full bg-gray-50 relative"
        onClick={(e) => {
          e.preventDefault();
          if (isSidepanelOpen?.isOpen) {
            setSidePanelOpen({ isOpen: false });
          }
        }}
      >
        <div className="flex justify-between items-center gap-4 p-2 z-10 absolute top-2 right-2 left-2 rounded">
          {/* Left section: Search User & Departments */}
          <div className="flex items-center gap-2">
            <SearchWithDropdown
              placeholder={`Search org chart`}
              loading={empList?.loading}
              keyword={keyword}
              setKeyword={setKeyword}
              onChange={onSearch}
              divClasses={"!rounded-xl"}
              dropdownClass={"!rounded-xl"}
              inputClasses={"!pl-0"}
              dropdownData={empList?.data?.map((item) => ({
                name: item?.firstName + " " + item?.lastName,
                subItem: item?.positionDetails?.title || "No position",
                image: item?.image?.url,
                _id: item?._id,
                type: "user",
              }))}
            />

            <div className="relative" data-tooltip-id="departments-dropdown">
              <MultiselectDropdown
                buttonPlaceholder={"Search Departments"}
                xPlacement={"bottom"}
                isCheckbox={true}
                dropdownData={department}
                setDropdownData={setDepartment}
                buttonArrowIconClasses={"!text-sm !right-3"}
                buttonLabelClasses={
                  "!text-sm !font-medium !border-black !text-left"
                }
                dropdownContainer="!w-52 lg:min-w-[250px] !left-[7px] !mt-[33px] !rounded-none relative before:absolute before:content-[''] before:left-[-15px] before:right-0 before:top-[-15px] before:rounded-[4px] before:w-[30px] before:h-[30px] before:transform before:rotate-45 before:bg-[#fff] dark:before:bg-[#94A3B8] before:translate-x-[-50%] before:shadow-[0px_2px_21px_2px_rgba(0,0,0,0.1)] before:z-[-1] before:mx-auto before:my-0 before:text-center"
                dropdownButtonClass="!w-full !h-12 !rounded-xl !bg-white !pr-14 !bg-[#eeeeee] dark:!bg-slate-700 !text-[#ababab] !px-4 font-medium"
                buttonsinglelabelclass="!text-xs md:!text-sm !font-medium"
                selectedItems={(val) => setSelectedDepartments(val)}
                isSingleSelect={true}
              />
            </div>
            <div className="ml-2" data-tooltip-id="toggle-option">
              <ToggleSwitch
                onToggle={handleToggleChange}
                isUnassigned={isUnassigned}
                label1={"Highlight Open Positions"}
                label2={"Highlight Open Positions"}
              />
              <Tooltip
                id="toggle-option"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100"
                render={() => (
                  <div className="text-white dark:text-slate-200">
                    {!isUnassigned
                      ? "Click to highlight open positions."
                      : "Click to Clear Highlights."}
                  </div>
                )}
              />
            </div>
            <div className="" data-tooltip-id="toggle-option-view">
              <ToogleButton
                onToggle={handleToggleViewChange}
                isToggled={view === "hierarchy"}
                label1={"Hierarchy View"}
                label2={"Vertical View"}
              />
              <Tooltip
                id="toggle-option-view"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100"
                render={() => (
                  <div className="text-white dark:text-slate-200">
                    {view === "hierarchy"
                      ? "Click to show vertical view."
                      : "Click to show hierarchy view."}
                  </div>
                )}
              />
            </div>
          </div>

          {/* Right section: Zoom, Export, Reset, etc. */}
          <div className="flex items-center gap-2 ml-auto">
            {!partialTree && (
              <div className="relative">
                <ExportDropdown
                  data={{ icon: "fa-regular fa-download", name: "Export" }}
                  _id="1"
                  xPlacement="bottomLeft"
                  dropdownContainer="!w-36"
                  // downloadTreeAsPDF={charttopdf}
                  withoutPdf = {true}
                />
              </div>
            )}
            {partialTree && selectedDepartments?.length > 0 && (
              <div className="relative px-2">
                <ExportDropdown
                  data={{
                    icon: "fa-regular fa-download",
                    name: "Export",
                  }}
                  _id="2"
                  xPlacement="bottomLeft"
                  dropdownContainer="!w-36"
                  // downloadTreeAsPDF={charttopdf}
                  userId={parentNode}
                  selectedDepartments={selectedDepartments}
                />
              </div>
            )}

            {userRole?.code !== "COMPANY-MANAGER" && (
              <div data-tooltip-id="import-csv">
                <Button
                  buttonFunction={() => setImportModal({ isOpen: true })}
                  buttonLabel={"Import"}
                  buttonClasses={
                    "ml-2 !bg-white dark:!bg-slate-800 !border-orange-500 border !text-orange-500 "
                  }
                  buttonIcon={"fa-regular fa-file-import"}
                  buttonIconPosition={"left"}
                />
                <Tooltip
                  id="import-csv"
                  place="bottom"
                  className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                  render={() => (
                    <div className="text-white">
                      Click to upload CSV & XLSX.
                    </div>
                  )}
                />
              </div>
            )}
            <div data-tooltip-id="zoom-in">
              <Button
                buttonFunction={handleZoomIn}
                buttonIcon={"fa-regular fa-plus"}
                buttonIconPosition={"left"}
                buttonClasses="!bg-white dark:!bg-slate-800 !border-orange-500 border !text-orange-500"
              />
              <Tooltip
                id="zoom-in"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                render={() => (
                  <div className="text-white">Click to zoom in the chart.</div>
                )}
              />
            </div>

            <div data-tooltip-id="reset">
              <Button
                buttonFunction={handleReset}
                buttonIcon={"fa-sharp fa-solid fa-rotate-left"}
                buttonIconPosition={"left"}
                buttonClasses="!bg-white dark:!bg-slate-800 !border-orange-500 border !text-orange-500"
              />
              <Tooltip
                id="reset"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                render={() => (
                  <div className="text-white">Click to reset the chart.</div>
                )}
              />
            </div>

            <div data-tooltip-id="zoom-out">
              <Button
                buttonFunction={handleZoomOut}
                buttonIcon={"fa-regular fa-minus"}
                buttonIconPosition={"left"}
                buttonClasses="!bg-white dark:!bg-slate-800 !border-orange-500 border !text-orange-500"
              />
              <Tooltip
                id="zoom-out"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                render={() => (
                  <div className="text-white">Click to zoom out the chart.</div>
                )}
              />
            </div>

            <div data-tooltip-id="share">
              <Button
                buttonFunction={shareChart}
                buttonIcon={"fa-regular fa-share"}
                buttonIconPosition={"left"}
                buttonClasses="!bg-white dark:!bg-slate-800 !border-orange-500 border !text-orange-500"
              />
              <Tooltip
                id="share"
                place="bottom"
                className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                render={() => (
                  <div className="text-white">Click to share chart.</div>
                )}
              />
            </div>
          </div>
        </div>

        <div className="w-full">
          {isLoading ? (
            <div className="flex justify-center items-center h-[70vh]">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
              <span className="ml-3 text-orange-500 font-semibold">
                Loading chart...
              </span>
            </div>
          ) : chartData?.length > 0 ? (
            <div
              ref={d3Container}
              className="w-full flex"
              style={{ height: "calc(100vh - 340px)" }}
            />
          ) : (
            <div className="flex justify-center items-center h-[70vh] text-gray-400 text-lg">
              No chart found for the selected department.
            </div>
          )}
        </div>
        <CopyUrl
          setCopyUrlModal={setCopyUrlModal}
          copyUrlModal={copyUrlModal}
        />
      </div>
      <NodeEditResearch
        editNode={editNode}
        empDetails={empDetails}
        setEmpDetails={setEmpDetails}
        isSidepanelOpen={isSidepanelOpen}
        setSidePanelOpen={setSidePanelOpen}
        exportPartialTree={exportPartialTree}
        setSelectUser={setSelectUser}
        selectUser={selectUser}
        setSelectedPosition={setSelectedPosition}
        selectedPosition={selectedPosition}
        parentNode={parentNode}
      />
      <NodeDelete
        open={isDeleteModal?.isOpen}
        onClose={() => setDeleteModal((pre) => ({ ...pre, isOpen: false }))}
        loading={isDeleting}
        deleteHandler={deleteNode}
        deleteStatus={deleteStatus}
        setDeleteStatus={setDeleteStatus}
        hasChild={isDeleteModal?.data?.children?.length > 0 ? true : false}
      />
      <CsvUploadResearchChart
        importModal={importModal}
        setImportModal={setImportModal}
        loadChart={loadLinearChart}
      />
      <AssignModal
        open={assignModal?.isOpen}
        loading={assignModal?.loading}
        onClose={() => setAssignModal((pre) => ({ ...pre, isOpen: false }))}
        deleteHandler={usAssignNode}
        title={
          <>
            Confirm removal of{" "}
            <strong>
              {/* {assignModal?.name?.substring(0, 10) +
                      (`${assignModal?.name}`.length > 10 ? "..." : "")} */}
              {assignModal?.name}
            </strong>
          </>
        }
        customMessage={
          <>
            Are you sure you want to remove{" "}
            <strong>
              {assignModal?.name?.substring(0, 25) +
                (`${assignModal?.name}`.length > 25 ? "..." : "")}
            </strong>{" "}
            from the organization chart?
          </>
        }
        deleteButtonIcon={"fa-regular fa-user-xmark"}
        deleteButtonLabel={"Remove"}
      />
    </>
  );
};

export default TestChart;
